import { usePrintingMethod } from '@modules/configuration/Printers/hooks/usePrintingMethod';
import { useEffect, useState } from 'react';

// 🎯 Hook para verificar si hay una impresora seleccionada
export const usePrinterSelection = () => {
    const [hasPrinterSelected, setHasPrinterSelected] = useState<boolean>(false);
    const { isPrintNode } = usePrintingMethod();

    useEffect(() => {
        // Verificar si hay una impresora seleccionada en localStorage
        const checkPrinterSelection = () => {
            // Si el método es PDF, siempre considerar que hay "impresora" seleccionada
            if (!isPrintNode) {
                setHasPrinterSelected(true);
                return;
            }

            // Si el método es PrintNode, verificar si hay impresora seleccionada
            const selectedPrinterId = localStorage.getItem('selectedPrinterId');
            setHasPrinterSelected(!!selectedPrinterId);
        };

        // Verificar al montar el hook
        checkPrinterSelection();

        // Escuchar cambios en localStorage
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'selectedPrinterId') {
                checkPrinterSelection();
            }
        };

        // Agregar listener para cambios en localStorage
        window.addEventListener('storage', handleStorageChange);

        // También escuchar cambios en el mismo tab (cuando se actualiza desde el mismo contexto)
        const handleCustomStorageChange = () => {
            checkPrinterSelection();
        };

        // Agregar listener personalizado para cambios en el mismo tab
        window.addEventListener(
            'printerSelectionChanged',
            handleCustomStorageChange
        );

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener(
                'printerSelectionChanged',
                handleCustomStorageChange
            );
        };
    }, [isPrintNode]); // ✅ Agregar isPrintNode como dependencia

    return { hasPrinterSelected };
}; 